/** Ab dieser Zeilenanzahl Export-Callbacks erst bei Bedarf (Export-Section). */
export const EXPORT_PREP_DEFER_THRESHOLD = 5000;

export function shouldDeferExportPrep(count) {
  return Number(count) > EXPORT_PREP_DEFER_THRESHOLD;
}
